import { defineComponent } from "vue";
import { Key } from "../../types/skyward/svg";
import Svg from "./svg";
import { OptionalVueProp, VueProp } from "./vueHelpers";

/*
 Warning: This component is a very limited implementation of ContentMessageArea.  Reactivity (by changing any of the props after initial rendering) is not recommended.
 PR 4230468 will update this component to be more stable.
 */

export enum ContentMessageAreaType
{
    Error = "Error",
    Confirmation = "Confirmation",
    Information = "Information"
};

export default /*#__PURE__*/ defineComponent(
    {
        name: "contentMessageArea",
        props:
        {
            message: VueProp(String),
            cmaType: VueProp(String),
            hidden: OptionalVueProp(Boolean),
        },
        mounted()
        {
            const context = this.$el as HTMLElement;
            window.skyward.events.applyLoadActionClass(context);
            window.skyward.window.notifyDOMLoad(context);
        },
        render()
        {
            let svgName: Key = "Error";
            let messageClassName = "cmaErrorMessage";
            switch (this.cmaType)
            {
                case ContentMessageAreaType.Error:
                    svgName = "Error";
                    messageClassName = "cmaErrorMessage";
                    break;
                case ContentMessageAreaType.Confirmation:
                    svgName = "Check";
                    messageClassName = "cmaConfirmationMessage";
                    break;
                case ContentMessageAreaType.Information:
                    svgName = "Info";
                    messageClassName = "cmaInformationMessage";
                    break;
                default:
                    console.warn('Unsupported CMA Type.');
                    break;
            }

            return (
                <div data-load-action="contentMessageArea.init"
                    class=
                    {{
                        ["contentMessageArea"]: true,
                        ["cmaHidden"]: this.hidden
                    }}>
                    <div class={`cmaMessageArea ${messageClassName} pointer`}>
                        <Svg name={svgName}></Svg>
                        <div class="cmaMessage cmaMessage--flexed js-eelPositionManagerGetRowsForHeight pointer">
                            <span class="cmaMessageText">{this.message}</span>
                        </div>
                    </div>
                </div>
            );
        }
    }
);